// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"274":"a5110d9b","617":"cec61161","670":"2fd1c869"}[chunkId] + ".chunk.css";
};